import api from '../../../utils/api';

/**
 * Check if a store at the given coordinates is already approved and listed.
 * @returns {{ already_listed: boolean }}
 */
export async function checkStoreListed(latitude, longitude) {
  const response = await api.get('/stores/check/', {
    params: { latitude: Number(latitude), longitude: Number(longitude) },
  });
  return response.data;
}

/**
 * Submit a feed/seed store for approval. Logged-in users only.
 * Store is created with status=PENDING; app owner approves in admin.
 */
export async function submitStore(payload) {
  const response = await api.post('/stores/submissions/', payload);
  return response.data;
}
